// ═══════════════════════════════════════════════════════════
//  OrderQuote.jsx — lógica 100% original, nuevo shell visual
// ═══════════════════════════════════════════════════════════
import React, { useState, useEffect, useRef } from 'react'
import { useParams, useNavigate } from 'react-router-dom';
import { Header } from '../common/Header/Header'
import QRCode from "react-qr-code";
import { createPortal } from 'react-dom';
import { PreOrderFetchAPI } from '../../api/PaymentPost/PreOrder';
import { DeletedTempOrdersFetchAPI } from '../../api/DeletedTemporalOrders';
import { MailFetchAPI } from '../../api/Mail';
import initData from '../Home/initData';
import validDomain from '../../utils/validDomain';
import { RenderIf } from '../../utils/RenderIf';
import Socket from '../../utils/Socket.config';
import { FormatDateTime } from '../../utils/FormatDate';
import PhoneInput from 'react-phone-input-2';
import { PDFDownloadLink } from '@react-pdf/renderer';
import DocPdf from '../Pdf/DocPdf';
import { BsCheckLg } from "react-icons/bs";
import { FiDownload } from "react-icons/fi";
import { OrdersFetchAPI } from '../../api/Orders';
import { BusinessFetchAPI } from '../../api/Business';
import { DgiFetchAPI } from '../../api/Dgi';
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';
import { AsapFetchAPI } from '../../api/Asap';
import { TookanFetchAPI } from '../../api/Tookan';
import logo_sp from '../img/logos/logo.png';
import '../ShoppingCart/cart.css';
import Swal from 'sweetalert2';
import HeaderMain from '../Home/Headers/HeaderMain';
import Loader from '../Home/Loader';
import LoginUser from '../Profile/LoginUser';
import ErrorAlert from '../Alerts/ErrorAlert';
import AlertSmall from '../Alerts/AlertSmall';
import Form from 'react-bootstrap/Form';
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl';



/* ── ICONS ── */
const IcoDoc     = ()=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>;
const IcoTrash   = ()=><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/></svg>;
const IcoPay     = ()=><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>;
const IcoDown    = ()=><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>;
const IcoFinish  = ()=><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>;
const IcoPlus    = ()=><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const IcoStore   = ()=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>;
const IcoReceipt = ()=><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>;
const IcoUser    = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
const IcoNote    = ()=><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>;
const IcoFile    = ()=><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>;
const IcoX       = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IcoWarn    = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{flexShrink:0,marginTop:1}}><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>;
const IcoClip    = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>;

/* ═══════════════════════════════════════════════════════════
   COMPONENT
═══════════════════════════════════════════════════════════ */
const OrderQuote = () => {
    const navigate = useNavigate();



    /* ═══════════════════════════════════════════════════════
       LÓGICA ORIGINAL — 100% INTACTA
    ═══════════════════════════════════════════════════════ */
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [formatVoucher, setformatVoucher] = useState("");
    const [modalShowVoucher, setmodalShowVoucher] = useState(false)
    const [loginrequired, setLoginRequired] = useState(false);
    const [modalUser, setModalUser] = React.useState(false);
    const [domainData, setDomainData] = useState("");

    const [orderNote, setOrderNote] = useState("");
    const [attachedFiles, setAttachedFiles] = useState([]);
    const [uploading, setUploading] = useState(false);

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setAttachedFiles(Array.from(e.target.files));
        }
    };

    const handleSaveFiles = async () => {
        if (!attachedFiles.length) return;
        setUploading(true);
        try {
            const formData = new FormData();
            attachedFiles.forEach((file, idx) => { formData.append('files', file); });
            formData.append('_id', orderData._id);
            // Aquí deberías llamar a tu API para subir los archivos
            const response = await PreOrderFetchAPI.updateOrderTempPreOrderFile(formData, token);
            console.log(response);
            AlertSmall('Archivos adjuntados correctamente', 'success');
            setAttachedFiles([]);
        } catch (err) {
            AlertSmall('Error al adjuntar archivos', 'error');
        } finally {
            setUploading(false);
        }
    };

    const [name, setName] = useState(() => {
        if (localStorage.getItem('client') != null && localStorage.getItem('client') != undefined && localStorage.getItem('client') != '') {
            let data = JSON.parse(localStorage.getItem('client'))
            if (data.name !== null && data.name !== undefined && data.name !== "" && data.name !== "Invitado") return data.name;
        }
        return "";
    });
    const [ruc, setRuc] = useState(() => {
        if (localStorage.getItem('client') != null && localStorage.getItem('client') != undefined && localStorage.getItem('client') != '') {
            let data = JSON.parse(localStorage.getItem('client'))
            if (data.ruc !== null && data.ruc !== undefined && data.ruc !== "") return data.ruc;
            else return 0;
        }
        return 0;
    });
    const [dv, setDv] = useState(() => {
        if (localStorage.getItem('client') != null && localStorage.getItem('client') != undefined && localStorage.getItem('client') != '') {
            let data = JSON.parse(localStorage.getItem('client'))
            if (data.dv !== null && data.dv !== undefined && data.dv !== "") return data.dv;
            else return 0;
        }
        return 0;
    });
    const [email, setEmail] = useState(() => {
        if (localStorage.getItem('client') != null && localStorage.getItem('client') != undefined && localStorage.getItem('client') != '') {
            let data = JSON.parse(localStorage.getItem('client'))
            if (data.email !== null && data.email !== undefined && data.email !== "" && data.email !== "invitado@invitado.com") return data.email;
            else return "";
        }
        return "";
    });
    const [phone, setPhone] = useState(() => {
        if (localStorage.getItem('client') != null && localStorage.getItem('client') != undefined && localStorage.getItem('client') != '') {
            let data = JSON.parse(localStorage.getItem('client'))
            if (data.phone !== null && data.phone !== undefined && data.phone !== "" && data.phone !== "0000000") return data.phone;
            else return "";
        }
        return "";
    });
    const [machine_code, setmachine_code] = useState(() => {
        if (localStorage.getItem("machine") != "" && localStorage.getItem("machine") != undefined)
            return JSON.parse(localStorage.getItem("machine")).code;
        return null;
    });

    const [modalfinishQuote, setModalFinishQuote] = useState(false);
    const socketRef = useRef(null);
    const emailedRef = useRef(false);
    const [isRejected, setIsRejected] = useState(false);
    const [rejectInfo, setRejectInfo] = useState({ reason: '', at: null });

    let logo = "";
    if (localStorage.getItem('logo') != null || localStorage.getItem('logo') != undefined || localStorage.getItem('logo') != "")
        logo = localStorage.getItem('logo');

    const [clientData, setClientData] = useState(() => {
        if (localStorage.getItem('client') != null && localStorage.getItem('client') != undefined && localStorage.getItem('client') != '')
            return JSON.parse(localStorage.getItem('client'));
        return null;
    });
    const [guestClient, setGuestClient] = useState(() => {
        if (localStorage.getItem('guestClient') != null && localStorage.getItem('guestClient') != undefined && localStorage.getItem('guestClient') != '')
            return localStorage.getItem('guestClient');
        return null;
    });

    const { order_code } = useParams();
    const [branchoffice_code, setBranchOfficeCode] = useState(() => {
        if (localStorage.getItem("branchoffice") != "" && localStorage.getItem("branchoffice") != undefined)
            return JSON.parse(localStorage.getItem("branchoffice")).code;
    });
    const [business_code, setbusiness_code] = useState(() => {
        if (localStorage.getItem("business") != "" && localStorage.getItem("business") != undefined)
            return JSON.parse(localStorage.getItem("business")).code;
    });
    const [addressNowLocation, setAddressNowLocation] = useState(() => {
        if (localStorage.getItem('addressNowLocation') != null && localStorage.getItem('addressNowLocation') != undefined && localStorage.getItem('addressNowLocation') != '')
            return JSON.parse(localStorage.getItem('addressNowLocation'));
        return null;
    });

    const [eventHandler, setEventHandler] = useState(0);
    const [orderData, setOrderData] = useState({ createdAt: "2023-07-25T10:02:35.000+00:00", cufe: "0", dgi_qr: "0" });
    const [cardsItems, setCardItems] = useState([]);
    const [listOrderHistroy, setOrderHistory] = useState([]);
    const [businessData, setBusinessData] = useState({ name: '' });
    const [dataStyleBusiness, setDataStyleBusiness] = useState({});
    const [branchOfficeData, setBranchofficeData] = useState({ ruc:"", dv:"", name:"", ruc_type:"", direction:"", dgi_name:"" });

    let machine = "", business = "", branchoffice = "", token = "";
    if (localStorage.getItem("branchoffice") != "" && localStorage.getItem("branchoffice") != undefined && localStorage.getItem("machine") != "" && localStorage.getItem("machine") != undefined) {
        token = undefined;
        branchoffice = JSON.parse(localStorage.getItem('branchoffice'));
        machine = JSON.parse(localStorage.getItem('machine'));
        business = JSON.parse(localStorage.getItem("business"));
    } else { navigate(`/branch`); }

    const [totalTaxes, setTotalTaxes] = useState([
        { total_base: 0, tax: "0%", total_tax: 0 }, { total_base: 0, tax: "7%", total_tax: 0 },
        { total_base: 0, tax: "10%", total_tax: 0 }, { total_base: 0, tax: "15%", total_tax: 0 }
    ]);

    const ASAP_STATUS_MAP = { 0:{key:'placed',label:'Order Placed'}, 6:{key:'confirmed',label:'Order Confirmed'}, 7:{key:'dispatched',label:'Order Dispatched'}, 2:{key:'completed',label:'Order Completed'}, 1:{key:'cancelled',label:'Order Cancelled'}, 100:{key:'driver_arrived',label:'Driver Arrived'}, 101:{key:'driver_started',label:'Driver Started'} };
    const TOOKAN_STATUS_MAP = { 0:{key:'placed',label:'Task Created'}, 1:{key:'assigned',label:'Assigned'}, 10:{key:'assigned',label:'Assigned'}, 6:{key:'arrived',label:'Driver Arrived'}, 2:{key:'started',label:'Picked Up'}, 3:{key:'completed',label:'Completed'}, 4:{key:'failed',label:'Failed'}, 9:{key:'cancelled',label:'Cancelled'}, 11:{key:'in_progress',label:'In Progress'} };
    const ASAP_FLOW = ['placed','confirmed','dispatched','completed'];
    const TOOKAN_FLOW = ['placed','assigned','arrived','started','completed'];
    const PLATFORM = (orderData?.delivery?.platform || '').toLowerCase();
    const STATUS_MAP = PLATFORM === 'tookan' ? TOOKAN_STATUS_MAP : ASAP_STATUS_MAP;
    const FLOW = PLATFORM === 'tookan' ? TOOKAN_FLOW : ASAP_FLOW;

    const [trackOpen, setTrackOpen] = useState(false);
    const [trackLoading, setTrackLoading] = useState(false);
    const [trackLog, setTrackLog] = useState([]);
    const [tookanTrackingLink, setTookanTrackingLink] = useState(null);
    const pollRef = useRef(null);
    const [emailsNotifications, setEmailsNotifications] = useState({});

    const latestEvent = trackLog?.[0] || null;
    const latestStatusCode = latestEvent?.code ?? null;
    const latestKey = STATUS_MAP[latestStatusCode]?.key ?? null;
    const isTerminal = latestKey === 'completed' || latestKey === 'cancelled' || latestKey === 'failed';
    const currentStepIndex = (() => { if (!latestKey) return -1; const idx = FLOW.indexOf(latestKey); return idx >= 0 ? idx : -1; })();

    const mapTookanLabelToCode = (textRaw) => {
        if (!textRaw) return null;
        const text = textRaw.replace(/<[^>]+>/g, '').toUpperCase();
        if (/\b(COMPLETED|SUCCESS|TASK\s+COMPLETED)\b/.test(text)) return 3;
        if (/\b(PICKED|PICK\s?UP|STARTED|TASK\s+STARTED)\b/.test(text)) return 2;
        if (/\b(ARRIVED|REACHED|AT\s+PICKUP|AT\s+DELIVERY|TASK\s+ARRIVED)\b/.test(text)) return 6;
        if (/\b(ASSIGNED|ACCEPTED|ACKNOWLEDGED|AUTO[-\s]?ASSIGNED)\b/.test(text)) return 10;
        if (/\b(EN[\s-]?ROUTE|ENROUTE|ON\s+THE\s+WAY)\b/.test(text)) return 11;
        if (/\b(CANCEL|CANCELLED|UNASSIGNED)\b/.test(text)) return 9;
        if (/\b(FAILED|FAIL)\b/.test(text)) return 4;
        if (/\b(CREATED|NEW|TASK\s+CREATED|BY\s+API)\b/.test(text)) return 0;
        return null;
    };

    const normalizeEvent = (e) => {
        if (PLATFORM === 'tookan') {
            const ts = e?.creation_datetime || e?.datetime || e?.logged_at || e?.created_at || e?.date || e?.timestamp || null;
            const labelDesc = e?.label_description || e?.description || e?.activity || '';
            let code = mapTookanLabelToCode(labelDesc);
            const label = (e?.label_description?.replace(/<[^>]+>/g, '') || e?.description || e?.activity || 'Status');
            const description = e?.description || '';
            return { id: e?.id || `${code ?? 'x'}-${ts}-${Math.random().toString(36).slice(2)}`, code, label, description, at: ts };
        }
        const code = e?.delivery_status ?? e?.status ?? null;
        const ts = e?.logged_at || e?.created_at || e?.date || e?.timestamp || null;
        return { id: e?.id || `${code}-${ts}-${Math.random().toString(36).slice(2)}`, code, label: ASAP_STATUS_MAP[code]?.label || (e?.title ?? `Status ${code}`), description: e?.description || e?.message || '', at: ts };
    };

    const sendMail = (EmailData) => {
        let token = undefined;
        let data = EmailData;
        console.log(data);
        try {
            const response = MailFetchAPI.sendMail(data, token);
            AlertSmall('Correo enviado con exito', 'success');
        } catch (err) {
            ErrorAlert('', err.response.data ? err.response.data.error : "Error al enviar correo", 'error');
            console.log(err);
        }
    };



    //Function to get a temporal order data by code
    const getTemporalOrderByCode = async (code, init) => {
        try {
            let token = undefined;
            const response = await OrdersFetchAPI.getTempOrderByCode(code, business_code, branchoffice_code, token);
            console.log(response);
            return response;
        } catch (err) {
            if (init == true) {
                if (err.response.data.error === "Orden no existente") {
                    AlertSmall("Cotizacion no encontrada", "warning");
                    navigate('/home/');
                } else {
                    navigate(`/branch/quote/${order_code}`)
                }

            } else {
                navigate('/home');
            }
        }
    };

    const getTemporalOrderById = async (order) => {
        try {
            let token = undefined;
            const response = await OrdersFetchAPI.getTempOrderById(order._id, token);
            let dataOrder = response.data.pre_order;
            navigate(`/cart/order/${true}/${dataOrder.code}/${dataOrder._id}`);
        } catch (err) { console.log(err); }
    };

    // update pre order
    const updatePreOrder = async (dataClient) => {
        let token = undefined;
        let json = {
            "is_authorized": true,
            "_id": orderData._id,

        };

        //console.log(dataClient);
        if (dataClient !== undefined && dataClient !== null) {
            json.client_id = clientData?.id;
            json.id_Client = 0;
            json.ruc = ruc !== "" && ruc !== "null" && ruc !== null && ruc !== undefined ? ruc : 0;
            json.dv = dv !== "" && dv !== "null" && dv !== null && dv !== undefined ? dv : 0;
            json.client_name = name !== "" && name !== "null" && name !== null && name !== undefined ? name : "Cliente generico";
            json.client_phone = phone !== "" && phone !== "null" && phone !== null && phone !== undefined ? phone : "0000000000";
            json.client_email = email !== "" && email !== "null" && email !== null && email !== undefined ? email : "";
            localStorage.removeItem('quoteData');
        }

        
        // Agregar la nota si existe
        if (orderNote && orderNote.trim() !== "") {
            // Deletes a pre-order and navigates to home
            json.note = orderNote.trim();
        }


        //console.log(emailsNotifications);
        let cc = []
        if (emailsNotifications?.enabled == true) {
            cc = [...emailsNotifications.cc, ...emailsNotifications.to]
            json.email_cc = cc
        }
        try {
            const response = await PreOrderFetchAPI.updateOrderTempPreOrder(json, token);
            AlertSmall("Cotizacion finalizada", "success");
            setModalFinishQuote(false);
            const dataNewQuote = await getTemporalOrderByCode(order_code);
            let newdataOrder = dataNewQuote.data.order
            let newShoppingCart = []

            newdataOrder.groups.forEach(item => {
                newShoppingCart.push({
                    ...item,
                    price: item.price.toFixed(2),
                    total: (item.price * item.amount).toFixed(2)
                });
            });
            let dataEmailJson = {
                "cc": cc,
                "template": "quote_detaills",
                "subject": "Cotizacion " + newdataOrder?.transaction_code,
                "email": email,
                "emit": {
                    "name": newdataOrder.branchoffice.name,
                    "ruc": "00000000-000000",
                    "dv": "00"

                },
                "branchoffice": {
                    "name": newdataOrder.branchoffice.name,
                },
                "business": {
                    "name": newdataOrder.business.name,
                },
                "client_name": newdataOrder.client_name,
                "client_ruc": newdataOrder.client_ruc,
                "client_dv": newdataOrder.client_dv,
                "client_phone": newdataOrder.client_phone,
                "code": newdataOrder.code,
                "business_color": newdataOrder.business.color,
                "discount_total": newdataOrder.discount.toFixed(2),
                "footer_note": "Esta cotizacion es valida por 15 dias.",
                "invoice_total": newdataOrder.total.toFixed(2),
                "items": newShoppingCart,
                "logo_url": logo,
                "sub_total": newdataOrder.subtotal.toFixed(2),
                "tax_total": newdataOrder.tax.toFixed(2),
                "tips_total": newdataOrder.tips.toFixed(2),
                "created_at": newdataOrder.createdAt,
                "business_color": dataStyleBusiness?.layaoutColor ? dataStyleBusiness.layaoutColor : "#000000",
                "buttonRedirect": "https://" + domainData + "/order/quote/" + newdataOrder.code,
                "note": newdataOrder.note ? newdataOrder.note : "",
                "transaction_code": newdataOrder?.transaction_code,
            };
            sendMail(dataEmailJson);
            setOrderData(dataNewQuote.data.order);
            setCardItems(dataNewQuote.data.order.groups);
            setOrderHistory(dataNewQuote.data.order.status_update_history);
        } catch (err) { AlertSmall("No se pudo actualizar la cotizacion", "error"); }
    };

    const handleFinishQuote = () => {
        if ((email === "" || email === null || email === undefined) && (phone === "" || phone === null || phone === undefined)) {
            ErrorAlert("Debe ingresar un correo y un numero de telefono para continuar", "Datos incompletos", "warning")
        } else {
            updatePreOrder(true)
        }
    }


    //delete preorder
    const deletePreOrder = async (code) => {
        let token = undefined;
        let jsonUpdate = {
            "order_code": code,
            "business_code": business_code,
            "branchoffice_code": branchoffice_code,
            "justification": "Cliente removio cotizacion",
            // Formats the voucher string for display, masking card digits
            "deleted": true,
            "status": 5,
            "user_id": 0,
            "deleted_code": "USER_REQUEST"
        }
        try {
            //We save the preorder
            await DeletedTempOrdersFetchAPI.newDeletedTempOrder(jsonUpdate, token);
            //We delete the preorder
            await PreOrderFetchAPI.deletePreOrder(jsonUpdate, token)
            let message = "Cotizacion eliminada con exito."
            let icon = "success"
            // Handles viewing the voucher by formatting and showing the modal
            localStorage.removeItem('quoteData');
            AlertSmall(message, icon)
            navigate("/home")
        } catch (err) {
            //console.log(err);
            ErrorAlert("Esta precuenta pertenece a otra sucursal", "Permiso denegado", "info")
        }
        // Loads the page data and initializes order/business/branch info
    }

    // function convert format voucher
    const formatVoucherString = () => {
        let voucher = orderData.voucher_response
        // Extraer el número de tarjeta ocultando los dígitos intermedios
        const maskedVoucher = voucher.replace(/(\d{6})\d+(\d{4})/g, "$1XXXXXX$2");

        // Construir el string formateado del voucher
        const formattedVoucher = `${maskedVoucher}`;
        setformatVoucher(formattedVoucher)
        //return formattedVoucher;
    };

    const handleViewCoucher = () => {
        formatVoucherString()
        setmodalShowVoucher(true)
    }




    // Socket connection and events
    /*useEffect(() => {
        //Connection with the sockets server 
        socketRef.current = Socket({ branchoffice_id, order_code });

        //We update the estate of the order depending of the signal of the order 
        socketRef.current.on(`branchoffice_${branchoffice_id}_orderUpdated_${order_code}`, (updatedOrder) => {
            //console.log(updatedOrder)
            //We set orders history 
            setOrderHistory(updatedOrder.status_update_history);
            //We refresh
            setEventHandler(1)
        });

        //We listen the updated event of the delivery (pos) update this event is to know if the order was approved or rejected
        socketRef.current.on(`delivery_order_updated`, (updatedOrder) => {
            //console.log("updatedOrder by delivery pos", updatedOrder)
            //We navigate to order confirmation
            if (updatedOrder.status === "order_accepted") {
                //We navigate to order confirmation
                navigate(`/order/${updatedOrder.metadata.response_registration.order_code}`);
            }
            //We check if the order was rejected
            if (updatedOrder.status === "rejected") {
                // intenta tomar una razón si viene en el payload
                const reason =
                    updatedOrder?.metadata?.reject_reason ||
                    updatedOrder?.metadata?.rejection_reason ||
                    updatedOrder?.justification ||
                    updatedOrder?.metadata?.justification ||
                    '';

                setIsRejected(true);
                setRejectInfo({
                    reason,
                    at: updatedOrder?.updatedAt || updatedOrder?.createdAt || new Date().toISOString()
                });

                // opcional: cortar polling de tracking si está abierto
                if (pollRef.current) {
                    clearInterval(pollRef.current);
                    pollRef.current = null;
                }
            }
        });

        // Listen for email notify result (optional UX/log)
        socketRef.current.on('orderEmailNotifyResult', (res) => {
            //console.log('[socket] orderEmailNotifyResult', res);
            // You can show a toast if you want:
            // if (res.success) Swal.fire({ toast:true, icon:'success', title:'Correo de orden enviado', timer:2000, showConfirmButton:false });
            // else if (res.duplicate || res.skipped) console.info('Email already handled/skipped');
            // else console.error('Email send error:', res.error);
        });

        // When the component is over, we  disconect the client of the socket 
        return () => {
            // Clean up
            try { socketRef.current?.off('orderEmailNotifyResult'); } catch { }
            try { socketRef.current?.disconnect(); } catch { }
            socketRef.current = null;
        };
    // Handles closing the login/register modal and updates client data
    }, [order_code])*/

    useEffect(() => {
        (async () => {
            try {
                const response = await getTemporalOrderByCode(order_code);
                console.log(response);
                if (localStorage.getItem('guestClient') !== null && localStorage.getItem('guestClient') !== undefined && localStorage.getItem('guestClient') !== 0 && localStorage.getItem('guestClient') !== "0") {
                    localStorage.setItem('lastorderguest', JSON.stringify(response.data.order));
                }
                setOrderData(response.data.order);
                setCardItems(response.data.order.groups);
                setOrderHistory(response.data.order.status_update_history);
                const response_business = await BusinessFetchAPI.getBusinessByCode(response.data.order.business.code);
                setBusinessData(response_business.data.business);
                const response_branch = await BranchOfficeFetchAPI.getBranchOfficeByCode(response.data.order.business.code, response.data.order.branchoffice.code);
                setBranchofficeData(response_branch.data.branchoffice);
                try {
                    const dgi_info_branch = await DgiFetchAPI.checkDGIContribuyent(response_branch.data.branchoffice.ruc);
                    console.log(dgi_info_branch);
                } catch (err) { console.log(err); }
            } catch (err) { console.log(err); }
        })();
    }, []);

    useEffect(() => { setOrderHistory(listOrderHistroy); setEventHandler(0); }, [eventHandler]);

    const closeTracking = () => {
        setTrackOpen(false);
        if (pollRef.current) { clearInterval(pollRef.current); pollRef.current = null; }
    };

    useEffect(() => {
        if (isTerminal && pollRef.current) { clearInterval(pollRef.current); pollRef.current = null; }
    }, [isTerminal]);

    const closedModalLoginAndRegister = () => {
        setClientData(JSON.parse(localStorage.getItem('client')));
        setLoginRequired(false);
    };

    const dataconsolidation = async (generalData) => {
        if (generalData == 'error') {
            navigate(`/branch/quote/${order_code}`)
        }

        //console.log("data", generalData);

        let data = generalData

        setDomainData(data.business.domain)
        setDataStyleBusiness(data.configuration)
        //Ecommerce content
        let dataEcommerceContentUi = data.ecommerce_content.ui_config;
        let themeInit = dataEcommerceContentUi.theme;
        if (localStorage.getItem("theme") == null || localStorage.getItem("theme") == undefined || localStorage.getItem("theme") == "") {
            localStorage.setItem("theme", themeInit);
        }
        if (data?.ecommerce_content?.head?.icon) {
            localStorage.setItem('iconGeneral', data.ecommerce_content?.head?.icon.url);
            if (data.ecommerce_content?.notifications?.order_email?.enabled == true) {
                setEmailsNotifications(data.ecommerce_content.notifications.order_email);
            }
        }
    };

    const handlerInit = async () => {
        try {
            let response = await validDomain();
            if (response !== undefined) {
                try { let response = await initData(); dataconsolidation(response); }
                catch (err) { console.log(err); }
            } else { console.log("No se pudo obtener el dominio válido"); }
        } catch (err) { console.log(err); }
    };

    //We get the page data 
    useEffect(() => {
        (async () => {
            try {
                const response = await getTemporalOrderByCode(order_code, true);
                //console.log(response);
                if (localStorage.getItem('guestClient') !== null && localStorage.getItem('guestClient') !== undefined && localStorage.getItem('guestClient') !== 0 && localStorage.getItem('guestClient') !== "0") {
                    localStorage.setItem('lastorderguest', JSON.stringify(response.data.order));
                }
                // Closes the tracking modal and clears polling
                setOrderData(response.data.order);
                setCardItems(response.data.order.groups);
                setOrderHistory(response.data.order.status_update_history);
                //We get the business
                const response_business = await BusinessFetchAPI.getBusinessByCode(response.data.order.business.code)
                //We set the business data 
                setBusinessData(response_business.data.business)
                //We get the branchoffice info 
                // Stops polling if order is in terminal state
                const response_branch = await BranchOfficeFetchAPI.getBranchOfficeByCode(response.data.order.business.code, response.data.order.branchoffice.code);
                //We set the business data 
                setBranchofficeData(response_branch.data.branchoffice);
                try {
                    //We get the dgi info 
                    const dgi_info_branch = await DgiFetchAPI.checkDGIContribuyent(response_branch.data.branchoffice.ruc);
                    //console.log(dgi_info_branch)
                    //setBranchofficeData( {dgi_name: dgi_info_branch.data.dgi_response.dNomb}, ...branchOfficeData)
                } catch (err) {
                    // Renders the list of order items (products), including discounts, notes, and QR codes
                    //console.log(err)
                }



                if (machine_code && machine_code !== "" && machine_code !== undefined && machine !== "" && machine !== undefined && machine !== null) {
                    handlerInit();
                    //console.log(machine_code);
                }

            } catch (err) {
                //console.log(err)
            }

        })()
    }, [machine_code]);

    const [loading, setLoading] = useState(true);
    /* ═══════════════════════════════════════════════════════
       FIN LÓGICA ORIGINAL
    ═══════════════════════════════════════════════════════ */

    /* ── render products ── */
    const renderProducts = () => (
        <>
            {cardsItems.map((options, idx) => (
                <div className="oq-product" key={options._id || idx}>
                    <img className="oq-product-img" src={buildCloudinaryImageUrl({ url: options.img, width: 300, quality: "auto", type: "image" }) || undefined} alt={options.name} />
                    <div className="oq-product-body">
                        <div className="oq-product-top">
                            <span className="oq-product-name">{options.name}</span>
                            <span className="oq-product-price">${options.price.toFixed(2)}</span>
                        </div>
                        <div className="oq-product-meta">
                            <span className="oq-product-qty">× {options.amount}</span>
                            {options.discount !== undefined && (
                                <span className="oq-product-discount">− ${options.discount.toFixed(2)}</span>
                            )}
                        </div>
                        {options.segments?.length > 0 && (
                            <div className="oq-product-seg">
                                {options.segments.map((s, si) => (
                                    <span key={si}>{si > 0 ? ' · ' : ''}{s.item.name}</span>
                                ))}
                            </div>
                        )}
                        {options.note && options.note !== "" && (
                            <div className="oq-product-note"><IcoNote /> {options.note}</div>
                        )}
                        {options.type === "reservable" && options.reservation_code && options.reservation_code !== "" && (
                            <div style={{marginTop:'.5rem',display:'flex',justifyContent:'center'}}>
                                <QRCode value={options.reservation_code} size={110} bgColor="#ffffff" fgColor="#000000" level="H" />
                            </div>
                        )}
                    </div>
                </div>
            ))}
            {orderData.is_authorized == false && (
                <button className="oq-add-more-btn" onClick={() => navigate('/menu')}>
                    <IcoPlus /> Agregar más productos
                </button>
            )}
        </>
    );

    /* ── MODAL FINISH QUOTE ── */
    // FinishModal is defined OUTSIDE this component (see bottom of file)
    // to prevent unmount/remount on every keystroke.
    const finishModalProps = {
        name, setName, email, setEmail, phone, setPhone,
        ruc, setRuc, dv, setDv,
        orderNote, setOrderNote,
        attachedFiles, uploading,
        handleFileChange, handleSaveFiles,
        orderData, cardsItems, branchOfficeData,
        onClose: () => setModalFinishQuote(false),
        onFinish: handleFinishQuote,
    };

    /* ═════════════════════════════════════════════════════
       RENDER
    ═════════════════════════════════════════════════════ */
    return (
        <>
            {loading && <Loader onFinish={() => setLoading(false)} />}

            {!loading && (
                <div className="ecommerce-wrapper">
                    <HeaderMain />

                    {loginrequired === false ? (
                        <div className="oq-page">
                            <div className="container" style={{maxWidth:960}}>

                                {/* guest banner */}
                                {guestClient !== 0 && guestClient !== "0" && (
                                    <div className="oq-guest-banner" onClick={() => setLoginRequired(true)}>
                                        <IcoWarn />
                                        Aún no tienes cuenta. Para una mejor experiencia,&nbsp;
                                        <a href="#" onClick={e => e.preventDefault()}>regístrate aquí</a>
                                    </div>
                                )}

                                {/* main card */}
                                <div className="oq-card">

                                    {/* ── card header ── */}
                                    <div className="oq-card-header">
                                        <button className="oq-card-title" onClick={() => navigate("/home")}>
                                            <IcoStore /> {businessData.name}
                                        </button>
                                        <div className="oq-code-badge">
                                            <IcoReceipt />
                                            Cotización&nbsp;<span>{orderData.transaction_code ? orderData.transaction_code : orderData.code}</span>
                                        </div>
                                    </div>

                                    {/* ── info blocks ── */}
                                    {orderData.is_authorized === true && (
                                        <div style={{padding:'1rem 1.4rem 0'}}>
                                            <div className="oq-info-block">
                                                <div className="oq-info-block-title"><IcoUser /> Información del cliente</div>
                                                <div className="oq-info-row"><span className="oq-info-row-label">Nombre</span><span className="oq-info-row-val">{orderData.client_name}</span></div>
                                                <div className="oq-info-row"><span className="oq-info-row-label">Teléfono</span><span className="oq-info-row-val">{orderData.client_phone}</span></div>
                                                {orderData.client_email && <div className="oq-info-row"><span className="oq-info-row-label">Email</span><span className="oq-info-row-val">{orderData.client_email}</span></div>}
                                                <div className="oq-info-row"><span className="oq-info-row-label">RUC</span><span className="oq-info-row-val">{orderData.client_ruc}</span></div>
                                                <div className="oq-info-row"><span className="oq-info-row-label">DV</span><span className="oq-info-row-val">{orderData.client_dv}</span></div>
                                            </div>
                                        </div>
                                    )}

                                    {orderData.note && orderData.note !== "" && (
                                        <div style={{padding:'0 1.4rem'}}>
                                            <div className="oq-info-block">
                                                <div className="oq-info-block-title"><IcoNote /> Nota de la cotización</div>
                                                <p style={{fontSize:'.83rem',color:'var(--text-2)',lineHeight:1.6,margin:0}}>{orderData.note}</p>
                                            </div>
                                        </div>
                                    )}

                                    {orderData.files && Array.isArray(orderData.files) && orderData.files.length > 0 && (
                                        <div style={{padding:'0 1.4rem'}}>
                                            <div className="oq-info-block">
                                                <div className="oq-info-block-title"><IcoFile /> Archivos adjuntos</div>
                                                <div className="oq-file-grid">
                                                    {orderData.files.map((file, idx) => (
                                                        <a key={idx} className="oq-file-item"
                                                            href={file.url || file} target="_blank" rel="noopener noreferrer" download>
                                                            <div className="oq-file-icon"><IcoFile /></div>
                                                            <span className="oq-file-label">Archivo {idx + 1}</span>
                                                        </a>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* ── products + summary grid ── */}
                                    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'1.5rem',padding:'1.25rem 1.4rem'}} className="oq-body-grid">
                                        <div>
                                            <div className="oq-section-label">Productos</div>
                                            {renderProducts()}
                                        </div>
                                        <div>
                                            <div className="oq-section-label">Resumen</div>
                                            <div className="oq-summary">
                                                <div className="oq-sum-row">
                                                    <span className="oq-sum-label">Descuento</span>
                                                    <span className="oq-sum-val danger">
                                                        − ${typeof orderData.discount === 'number' ? orderData.discount.toFixed(2) : orderData.discount}
                                                    </span>
                                                </div>
                                                <div className="oq-sum-row">
                                                    <span className="oq-sum-label">Subtotal</span>
                                                    <span className="oq-sum-val">
                                                        ${typeof orderData.subtotal === 'number' ? orderData.subtotal.toFixed(2) : orderData.subtotal}
                                                    </span>
                                                </div>
                                                <RenderIf isTrue={orderData.delivery !== undefined && orderData.delivery !== null}>
                                                    <div className="oq-sum-row">
                                                        <span className="oq-sum-label">Delivery</span>
                                                        <span className="oq-sum-val">
                                                            ${typeof orderData.delivery?.value === 'number' ? orderData.delivery.value.toFixed(2) : orderData.delivery?.value}
                                                        </span>
                                                    </div>
                                                </RenderIf>
                                                <div className="oq-sum-row">
                                                    <span className="oq-sum-label">ITBMS</span>
                                                    <span className="oq-sum-val">
                                                        ${typeof orderData.tax === 'number' ? orderData.tax.toFixed(2) : orderData.tax}
                                                    </span>
                                                </div>
                                                <div className="oq-sum-divider" />
                                                <div className="oq-sum-row oq-sum-total">
                                                    <span className="oq-sum-label">Total</span>
                                                    <span className="oq-sum-val">
                                                        ${typeof orderData.total === 'number' ? orderData.total.toFixed(2) : orderData.total}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* ── actions ── */}
                                    <div className="oq-actions">
                                        <button className="oq-btn-danger" onClick={() => deletePreOrder(orderData.code)}>
                                            <IcoTrash /> Eliminar cotización
                                        </button>

                                        {orderData.is_autorized === true ? (
                                            <PDFDownloadLink
                                                className="m-0 p-0"
                                                style={{flex:2,minWidth:180}}
                                                document={<DocPdf
                                                    doc_type={"price"} invoiceQR={"0"} invoiceDate={orderData.createdAt}
                                                    cufe={"0"} auth_protocol={orderData.auth_protocol ? orderData.auth_protocol : "00000000"}
                                                    receptor={{ name: orderData.client_name, ruc: orderData.client_ruc, direction: "Panama", dv: orderData.client_dv }}
                                                    emitter={branchOfficeData}
                                                    products={orderData.groups}
                                                    invoiceSubtotal={orderData.subtotal} totalTaxes={[]}
                                                    totalCashReceived={orderData.total} invoiceTotal={orderData.total}
                                                    invoiceTotalItbms={orderData.tax} paymentMethod={orderData.paymenthod}
                                                />}
                                            >
                                                <button className="oq-btn-ghost" style={{width:'100%'}}>
                                                    <IcoDown /> Descargar PDF
                                                </button>
                                            </PDFDownloadLink>
                                        ) : (
                                            orderData.is_authorized === false && (
                                                <button className="oq-btn-primary" onClick={() => setModalFinishQuote(true)}>
                                                    <IcoFinish /> Finalizar cotización
                                                </button>
                                            )
                                        )}

                                        {orderData.is_authorized === true && (
                                            <button className="oq-btn-primary" onClick={() => getTemporalOrderById(orderData)}>
                                                <IcoPay /> Proceder al Pago
                                            </button>
                                        )}
                                    </div>

                                </div>
                                {/* end oq-card */}

                            </div>
                        </div>
                    ) : (
                        <LoginUser modalUser={modalUser} setModalUser={setModalUser} shoppingCart={true} closedModalLoginAndRegister={closedModalLoginAndRegister} />
                    )}

                    {/* modal finalizar — componente externo para evitar unmount al escribir */}
                    {modalfinishQuote && <FinishModal {...finishModalProps} />}

                </div>
            )}
        </>
    );
};

/* responsive grid col en mobile */
const mobileGridStyle = `
@media(max-width:640px){
  .oq-body-grid{ grid-template-columns:1fr !important; }
}`;
const injectMobile = () => {
    if (!document.getElementById('oq-mobile')) {
        const el = document.createElement('style');
        el.id = 'oq-mobile'; el.textContent = mobileGridStyle;
        document.head.appendChild(el);
    }
};
if (typeof window !== 'undefined') injectMobile();


function FinishModal({
    name, setName, email, setEmail, phone, setPhone,
    ruc, setRuc, dv, setDv,
    orderNote, setOrderNote,
    attachedFiles, uploading,
    handleFileChange, handleSaveFiles,
    orderData, cardsItems, branchOfficeData,
    onClose, onFinish,
}) {
    return createPortal(
        <div className="oq-modal-overlay" onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
            <div className="oq-modal-panel">

                {/* header */}
                <div className="oq-modal-header">
                    <div className="oq-modal-header-icon"><IcoDoc /></div>
                    <div className="oq-modal-title">
                        Finalizar cotización
                        <span className="oq-modal-sub">Ingresa los datos del cliente para cerrar</span>
                    </div>
                    <button className="oq-modal-close" onClick={onClose}><IcoX /></button>
                </div>

                {/* body */}
                <div className="oq-modal-body">
                    <div className="oq-modal-cols">

                        {/* ── COL IZQUIERDA: formulario ── */}
                        <div>
                            <div className="oq-modal-summary-header">Datos del cliente</div>

                            {/* nombre */}
                            <div className="oq-field">
                                <label className="oq-label"><IcoUser /> Nombre completo</label>
                                <input
                                    className={`oq-input${!name || name.trim() === '' ? ' error' : ''}`}
                                    type="text" value={name || ''} placeholder="Ingresa tu nombre completo"
                                    onChange={e => setName(e.target.value)} required
                                />
                                {(!name || name.trim() === '') && <span className="oq-error-msg">Este campo es obligatorio</span>}
                            </div>

                            {/* email */}
                            <div className="oq-field">
                                <label className="oq-label"><IcoUser /> Correo electrónico</label>
                                <input
                                    className={`oq-input${!email || email.trim() === '' ? ' error' : ''}`}
                                    type="email" value={email || ''} placeholder="ejemplo@correo.com"
                                    onChange={e => setEmail(e.target.value)} required
                                />
                                {(!email || email.trim() === '') && <span className="oq-error-msg">Este campo es obligatorio</span>}
                            </div>

                            {/* teléfono */}
                            <div className="oq-field">
                                <label className="oq-label">Teléfono</label>
                                <Form.Group controlId="phone2">
                                    <PhoneInput
                                        country={'pa'}
                                        value={phone || ''}
                                        onChange={p => setPhone(p)}
                                        inputProps={{ name: 'phone2', required: true }}
                                        countryCodeEditable={false}
                                        enableSearch
                                        inputStyle={!phone || phone.trim() === '' ? { borderColor: '#dc3545' } : {}}
                                    />
                                    {(!phone || phone.trim() === '') && <span className="oq-error-msg">Este campo es obligatorio</span>}
                                </Form.Group>
                            </div>

                            {/* RUC / DV */}
                            <details style={{marginBottom:'.75rem'}}>
                                <summary className="oq-details-toggle">
                                    <IcoDoc /> RUC / DV
                                    <span style={{fontWeight:400,color:'var(--text-3)',marginLeft:'auto',fontSize:'.72rem'}}>opcional</span>
                                </summary>
                                <div className="oq-details-inner">
                                    <div className="oq-field" style={{marginBottom:0}}>
                                        <label className="oq-label">Número de RUC</label>
                                        <input className="oq-input" type="text" placeholder="0-0000-0" value={ruc} onChange={e => setRuc(e.target.value)} />
                                    </div>
                                    <div className="oq-field" style={{marginBottom:0}}>
                                        <label className="oq-label">Número DV</label>
                                        <input className="oq-input" type="number" placeholder="00" value={dv} onChange={e => setDv(e.target.value)} />
                                    </div>
                                </div>
                            </details>

                            {/* nota */}
                            <div className="oq-field">
                                <label className="oq-label"><IcoNote /> Nota <span className="oq-label-optional">— opcional</span></label>
                                <textarea
                                    className="oq-textarea"
                                    placeholder="Agrega un comentario para la cotización"
                                    value={orderNote}
                                    onChange={e => setOrderNote(e.target.value)}
                                    rows={3}
                                />
                            </div>

                            {/* archivos */}
                            <div className="oq-field">
                                <label className="oq-label"><IcoClip /> Adjuntar archivos <span className="oq-label-optional">— opcional</span></label>
                                <label className="oq-file-upload-area">
                                    <input type="file" style={{display:'none'}} onChange={handleFileChange}
                                        accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.txt" multiple />
                                    <span className="oq-file-upload-label">
                                        Arrastra o <span>haz clic para seleccionar</span>
                                    </span>
                                </label>
                                {attachedFiles.length > 0 && (
                                    <>
                                        <div className="oq-file-chips">
                                            {attachedFiles.map((f, i) => (
                                                <span className="oq-file-chip" key={i}><IcoFile /> {f.name}</span>
                                            ))}
                                        </div>
                                        <button className="oq-btn-ghost"
                                            style={{marginTop:'.5rem',minWidth:'unset',flex:'unset'}}
                                            onClick={handleSaveFiles} disabled={uploading}>
                                            {uploading ? 'Guardando...' : 'Guardar archivos'}
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>

                        {/* ── COL DERECHA: resumen ── */}
                        <div>
                            <div className="oq-modal-summary-header">Resumen de la cotización</div>

                            <div style={{marginBottom:'.85rem'}}>
                                <div className="oq-modal-meta-row"><strong>Código:</strong> {orderData.code || '—'}</div>
                                <div className="oq-modal-meta-row"><strong>Fecha:</strong> {orderData.createdAt ? FormatDateTime(orderData.createdAt) : '—'}</div>
                                <div className="oq-modal-meta-row"><strong>Sucursal:</strong> {branchOfficeData.name || '—'}</div>
                            </div>

                            <div style={{marginBottom:'.85rem'}}>
                                {cardsItems.map((item, idx) => (
                                    <div className="oq-modal-item" key={idx}>
                                        <span className="oq-modal-item-name">
                                            {item.name}
                                            <span className="oq-modal-item-badge">×{item.amount}</span>
                                        </span>
                                        <span className="oq-modal-item-price">${item.price.toFixed(2)}</span>
                                    </div>
                                ))}
                            </div>

                            <div className="oq-modal-totals">
                                <div className="oq-modal-total-row">
                                    <span>Subtotal</span>
                                    <span>${orderData.subtotal?.toFixed(2) || '0.00'}</span>
                                </div>
                                <div className="oq-modal-total-row">
                                    <span>Impuestos</span>
                                    <span>${orderData.tax?.toFixed(2) || '0.00'}</span>
                                </div>
                                <div className="oq-modal-total-row grand">
                                    <span>Total</span>
                                    <span>${orderData.total?.toFixed(2) || '0.00'}</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                {/* footer */}
                <div className="oq-modal-footer">
                    <button className="oq-btn-ghost" onClick={onClose}>Cancelar</button>
                    <button className="oq-btn-primary" onClick={onFinish}>
                        <IcoFinish /> Finalizar cotización
                    </button>
                </div>

            </div>
        </div>,
        document.body
    );
}

export default OrderQuote;